import { render, staticRenderFns } from "./Detail2.vue?vue&type=template&id=22f1ec22"
import script from "./Detail2.vue?vue&type=script&lang=js"
export * from "./Detail2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports